import DeviceId from 'utils/detectDevice'

const commonApiHeaders = {
  'X-App-Key': process.env.XAppKey,
}

const apiHeaders = (headers = {}) => {
  return { ...commonApiHeaders, ...headers }
}

const handleError = fn => (...params) => fn(...params).catch(console.error)

const API_URL = `https://ww4.shaadi.com/api`
const ACCESS_TOKEN_ENDPOINT = `${API_URL}/auth/guest`

const SUCCESS_STORIES_ENDPOINT = `${API_URL}/stories`

const FORM_DATA_ENDPOINT = `${API_URL}/list?fieldset=mother_tongue,religion,country,posted_by&fq={
 "mother_tongue":{"list_type" : "frequent"},
 "country":{"list_type" : "frequent"},
 "posted_by":{"list_type" : "relationship"}
 }`

const makeRequest = async (url, method, headers = apiHeaders()) => {
  const response = await fetch(
    new Request(url, {
      method,
      headers: new Headers(headers),
    })
  )
  const json = await response.json()
  return json.data
}

const sendRequest = async (url, method, headers = apiHeaders(), data = '') => {
  let response, json
  try {
    response = await fetch(url, {
      method: 'POST',
      headers,
      body: data,
    })
    json = await response.json()
  } catch (error) {
    console.log('err', error)
  }
  return json
}

const safeMakeRequest = handleError(makeRequest)

const saveToStorage = (token, tokenTime = new Date()) => {
  tokenTime.setMinutes(tokenTime.getMinutes() + 39)
  localStorage.setItem('accessToken', token)
  localStorage.setItem('accessTokenValidTill', tokenTime.getTime())
}

const getTokenFromServer = async apiHeaders => {
  const data = await safeMakeRequest(ACCESS_TOKEN_ENDPOINT, 'POST', apiHeaders)
  saveToStorage(data.access_token)
  return data.access_token
}

const getTokenFromLocalStorage = () => {
  const validTokenTime = localStorage.getItem('accessTokenValidTill')
  return validTokenTime > Date.now() && localStorage.getItem('accessToken')
    ? Promise.resolve(localStorage.getItem('accessToken'))
    : null
}

const getToken = (headers = apiHeaders()) => {
  return getTokenFromLocalStorage() || getTokenFromServer(headers)
}

const CHECK_EMAIL_ENDPOINT = `${API_URL}/users/guest/validate`

const isEmailTaken = async (accessToken, email) => {
  const response = await sendRequest(
    CHECK_EMAIL_ENDPOINT,
    'POST',
    apiHeaders({
      'X-Access-Token': accessToken,
      'Content-Type': 'application/json',
    }),
    JSON.stringify({ data: { email } })
  )
  return response
}

const getAffiliateData = async requestParams => {
  const response = await sendRequest(
    `${API_URL}/affiliates/clicks`,
    'POST',
    apiHeaders({
      'X-Platform': DeviceId.isDesktop() ? 'web' : 'm.shaadi.com',
      'X-User-Agent':
        typeof navigator !== 'undefined' ? navigator.userAgent : '',
      'Content-Type': 'application/json',
    }),
    JSON.stringify({ data: { ...requestParams } })
  )
  return response
}

const getFormData = async accessToken => {
  const data = await safeMakeRequest(
    FORM_DATA_ENDPOINT,
    'GET',
    apiHeaders({ 'X-Access-Token': accessToken })
  )
  return {
    countries: data.country.list,
    motherTongues: data.mother_tongue.list,
    postedBy: data.posted_by.list,
    religions: data.religion.list.map(data => ({
      value: data.id,
      label: data.text,
    })),
  }
}

const buildQueryString = requestParams => {
  return Object.keys(requestParams)
    .map(
      key =>
        `${key}=${
          requestParams[key] instanceof Object
            ? JSON.stringify(requestParams[key])
            : requestParams[key]
        }`
    )
    .join('&')
}

const getSuccessStories = ({ storiesCriteria }) => async accessToken => {
  const fieldset = ['id', 'title', 'description', 'photo1'].join(',')
  const fq = {
    success_stories: {
      status: 'Activated',
      to_be_displayed: ['Y'],
      photostatus: ['Add'],
      [storiesCriteria.storiesType]: [storiesCriteria.storiesDb],
    },
  }
  const requestParams = {
    type: 'success_stories',
    fieldset,
    fq,
    sort: { success_stories: ['-id'] },
    limit: { success_stories: '12' },
  }
  const requestUrl = `${SUCCESS_STORIES_ENDPOINT}?${buildQueryString(
    requestParams
  )}`
  const data = await safeMakeRequest(
    requestUrl,
    'GET',
    apiHeaders({
      'X-Access-Token': accessToken,
    })
  )
  return data.success_stories
}

export {
  getToken,
  getSuccessStories,
  getFormData,
  isEmailTaken,
  getAffiliateData,
}
